import React from "react";
import {Table, TableHeader, TableColumn, TableBody, TableRow, TableCell, User, Chip, Tooltip,} from "@nextui-org/react";
import { PencilIcon} from "@heroicons/react/24/outline";
import { EyeIcon,UserMinusIcon } from "@heroicons/react/24/outline";
import {columns, users} from "./Data";

const statusColorMap = {
  current: "success",
  Former: "danger",
};

export default function TableData() {
  const renderCell = React.useCallback((user, columnKey) => {
    const cellValue = user[columnKey];

    switch (columnKey) {
      case "name":
        return (
          <User
            avatarProps={{radius: "lg", src: user.avatar}}
            name={cellValue}
            
          > 
          </User>
        );
      case "role":
        return (
          <div className="flex flex-col">
            <p className="text-bold  text-sm capitalize">{cellValue}</p>
          </div>
        );
      case "status":
        return (
          <Chip className="capitalize" color={statusColorMap[user.status]} size="sm" variant="flat">
            {cellValue}
          </Chip>
        );
      case "actions":
        return (
          <div className="relative flex items-center gap-2">
            <Tooltip content="Details">
              <span className="text-lg text-default-400 cursor-pointer active:opacity-50">
                <EyeIcon className="w-5 h-6" />
              </span>
            </Tooltip>
            <Tooltip content="Edit user">
              <span className="text-lg text-default-400  cursor-pointer active:opacity-50">
             <PencilIcon className="w-5 h-6" />
              </span>
            </Tooltip>
            <Tooltip color="danger" content="Delete user">
              <span className="text-lg text-danger cursor-pointer active:opacity-50">
           <UserMinusIcon className="w-5 h-6" />
              </span>
            </Tooltip>
          </div>
        );
      default:
        return cellValue;
    }
  }, []);

  return (
  <Table aria-label="  Example table with custom cells overflow-x-auto">
      <TableHeader columns={columns}
     
      >
        {(column) => (
          <TableColumn className="bg-blue-500 text-white"   key={column.uid} align={column.uid === "actions" ? "center" : "start"}>
            {column.name}
          </TableColumn>
        )}
      </TableHeader>
      <TableBody items={users}>
        {(item) => (
          <TableRow key={item.id} className="dark:text-white">
            {(columnKey) => <TableCell>{renderCell(item, columnKey)}</TableCell>}
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
}
